module.exports = "<div class=\"wrapper\">\n  <div id=\"content-wrapper\">\n    <router-outlet></router-outlet>\n  </div>\n</div>\n<!-- Cambiar Sidebar -->\n"


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1